import { mdiContentCopy } from '@mdi/js';
import Command from './_Command';
import { ApryseSDK } from '../../pdf/ApryseSDK';

export default class CopyTextController extends Command {
    constructor() {
        super({
            Key: 'copyAnnotation',
            Enabled: ApryseSDK.textAnnotationCopyTextContext !== null,
            Path: mdiContentCopy,
            Callback: ApryseSDK.copyText,
        });
    }
}
